import { useTranslation } from 'react-i18next';

import { NotFoundData } from '../NotFoundData';

export const PlaceholderPage = () => {
  const { t } = useTranslation();

  return <NotFoundData title={t('common:messages.pageInDevelopment')} />;
};
